import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class FileManagerPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public getFileBox(fileBoxId: string): Observable<any> {
    const url = `/fileboxes/${fileBoxId}`;
    return this.apiService.get(url);
  }
  public updateFileManager(inspectionId: string, pointId: string, pluginId: string, value: string): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, value).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public createFolder(model: any): Observable<any> {
    const url = `/fileboxes/createFolder`;
    return this.apiService.post(url, model);
  }

  public uploadFiles(rootFileBox: string, parentFileBox: string, data: any): Observable<any> {
    const url = `/fileboxes/uploadFiles/rootfilebox/${rootFileBox}/parentfilebox/${parentFileBox}`;
    return this.apiService.postFormData(url, data);
  }

  public deleteItems(data): Observable<any> {
    const url = `/fileboxes/delete`;
    return this.apiService.post(url, data);
  }

  public deleteFileBox(id: string): Observable<any> {
    const url = `/fileboxes/${id}`;
    return this.apiService.delete(url);
  }

  public createFileBox(data): Observable<any> {
    const url = `/fileboxes`;
    return this.apiService.post(url, data);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, value: string): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, value, 'FileBoxId').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        } else {
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        }
      })
    );
  }
}
